module.exports = __webpack_public_path__ + "08_long_black.e7ce689a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/08_long_black.png
// module id = 6wbx
// module chunks = 0